import { trace, setCookie } from 'rytm-helpers'

export const initCookies = () => {
  // Document CLICK
  document.addEventListener("click", onDocClick, false)

}

// ##########################
// ### Doc event handlers ###
// Doc click
const onDocClick = (e) => {
  if (e.target.id == "cookieterms-dismiss") {
    e.preventDefault()
    handleCookiesDismiss(e.target)
  }
}

const handleCookiesDismiss = (trigger) => {
  const cookieName = trigger.dataset.cookieName;
  setCookie(cookieName, "true", 30);
  document.documentElement.classList.add("cookies-dismissed");
  document.body.classList.add("cookies-dismissed");
}